(function($){
        
	// Add Loaded Class
	$('.ptx-smallgrid').addClass('ptx-smallgrid--loaded');
  
})(jQuery);